import { GetStaticProps } from "next"
import Image from "next/image"
import { Box, Container, Grid, Hidden } from "@mui/material"
import Icon from "@mdi/react"
import { mdiCreditCardMultipleOutline, mdiCreditCardOutline } from "@mdi/js"
import { SiPaypal as Paypal } from "@icons-pack/react-simple-icons"

import Help from "containers/CategoryPage/Help"
import BreadCrumbs, { BreadCrumbAncestor } from "components/BreadCrumbs"

import useTranslation from "hooks/useTranslation"

import { getServerTranslations } from "utils/i18n/getServerTranslations"
import { helpCenterBreadCrumb } from "./index"

const PaymentInformation = () => {
	const { t } = useTranslation("help")

	const breadCrumb: BreadCrumbAncestor = {
		label: t("safeOnlinePayment"),
		href: "/help/payments",
	}
	return (
		<Box my={5}>
			<Box style={{ marginTop: "-40px", paddingBottom: "20px" }}>
				<BreadCrumbs
					breadCrumbsPaths={[
						{ ...helpCenterBreadCrumb, label: t(helpCenterBreadCrumb.label) },
					]}
					currentPath={breadCrumb}
				/>
			</Box>
			<Container>
				<Box pb={5} style={{ textAlign: "center", maxWidth: "650px", margin: "auto" }}>
					<h1>{t("safeOnlinePayment")}</h1>
					<p>{t("safePaymentText")}</p>
				</Box>
			</Container>
			<Container
				style={{
					position: "relative",
				}}
			>
				<Hidden mdDown>
					<Box
						my={5}
						py={5}
						style={{
							background:
								"url(https://res.cloudinary.com/safehero/image/upload/v1572508813/HelpCenter/zr6vgvulmlm317ogauod.png)",
							backgroundRepeat: "no-repeat",
							backgroundPosition: "center",
							margin: "auto",
							width: "100%",
						}}
					>
						<Grid container spacing={3}>
							<Grid item xs={12} md={6}>
								<div style={{ maxWidth: "320px", paddingLeft: "150px" }}>
									<Icon path={mdiCreditCardOutline} size={1} />
									<div className="h1" style={{ fontSize: "20px" }}>
										{t("prepaid")}
									</div>
									<p style={{ margin: "0" }}>{t("prepaidText")}</p>
								</div>
							</Grid>
							<Grid item xs={12} md={6}>
								<div
									style={{
										position: "absolute",
										maxWidth: "320px",
										margin: "auto",
										right: "120px",
									}}
								>
									<Image
										alt="sofortüberweisung"
										src="https://res.cloudinary.com/safehero/image/upload/v1572510112/HelpCenter/ngul6uuyzdruvdgygsvd.png"
										width={70}
										height={20}
										style={{
											maxWidth: "100%",
											height: "auto",
											objectFit: "contain",
										}}
									/>
									<div className="h1" style={{ fontSize: "20px" }}>
										{t("klarnaPayNow")}
									</div>
									<p style={{ margin: "0" }}>{t("klarnaPayNowText")}</p>
								</div>
							</Grid>
							<Grid item xs={12} md={6}>
								<Box
									my={5}
									style={{
										maxWidth: "320px",
										paddingLeft: "50px",
									}}
								>
									<Icon path={mdiCreditCardMultipleOutline} size={1} />
									<div className="h1" style={{ fontSize: "20px" }}>
										{t("creditCard")}
									</div>
									<p style={{ margin: "0" }}>{t("creditCardText")}</p>
								</Box>
							</Grid>
							<Grid item xs={12} md={6}>
								<div
									style={{
										position: "absolute",
										maxWidth: "320px",
										margin: "auto",
										right: "30px",
										marginTop: "50px",
									}}
								>
									<Image
										alt="kauf-auf-rechnung"
										src="https://res.cloudinary.com/safehero/image/upload/v1572510112/HelpCenter/ngul6uuyzdruvdgygsvd.png"
										width={70}
										height={20}
										style={{
											maxWidth: "100%",
											height: "auto",
											objectFit: "contain",
										}}
									/>
									<div className="h1" style={{ fontSize: "20px" }}>
										{t("klarnaPayLater")}
									</div>
									<p style={{ margin: "0" }}>{t("klarnaPayLaterText")}</p>
								</div>
							</Grid>
							<Grid item xs={12} md={6}>
								<div style={{ maxWidth: "320px", paddingLeft: "150px" }}>
									<Paypal size={20} />
									<div className="h1" style={{ fontSize: "20px" }}>
										{t("paypal")}
									</div>
									<p style={{ margin: "0" }}>{t("paypalText")}</p>
								</div>
							</Grid>
							<Grid item xs={12} md={6}>
								<div
									style={{
										position: "absolute",
										maxWidth: "320px",
										margin: "auto",
										right: "120px",
									}}
								>
									<Image
										alt="ratenkauf"
										src="https://res.cloudinary.com/safehero/image/upload/v1572510112/HelpCenter/ngul6uuyzdruvdgygsvd.png"
										width={70}
										height={20}
										style={{
											maxWidth: "100%",
											height: "auto",
											objectFit: "contain",
										}}
									/>
									<div className="h1" style={{ fontSize: "20px" }}>
										{t("klarnaPayOverTime")}
									</div>
									<p style={{ margin: "0" }}>{t("klarnaPayOverTimeText")}</p>
								</div>
							</Grid>
						</Grid>
					</Box>
				</Hidden>
				<Hidden mdUp>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={6}>
							<div className="h1">
								<Icon path={mdiCreditCardOutline} size={1} />
							</div>
							<div className="h1" style={{ fontSize: "20px" }}>
								{t("prepaid")}
							</div>
							<p style={{ margin: "0", color: "grey" }}>{t("prepaidText")}</p>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Box mt={1} className="h1">
								<Icon path={mdiCreditCardMultipleOutline} size={1} />
							</Box>
							<div className="h1" style={{ fontSize: "20px" }}>
								{t("creditCard")}
							</div>
							<p style={{ margin: "0", color: "grey" }}>{t("creditCardText")}</p>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Box mt={1} className="h1">
								<Image
									alt="ratenkauf"
									src="https://res.cloudinary.com/safehero/image/upload/v1572510112/HelpCenter/ngul6uuyzdruvdgygsvd.png"
									width={70}
									height={20}
									style={{
										maxWidth: "100%",
										height: "auto",
										objectFit: "contain",
									}}
								/>
							</Box>
							<div className="h1" style={{ fontSize: "20px" }}>
								{t("klarnaPayLater")}
							</div>
							<p style={{ margin: "0", color: "grey" }}>{t("klarnaPayLaterText")}</p>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Box mt={1} className="h1">
								<Paypal size={20} />
							</Box>
							<div className="h1" style={{ fontSize: "20px" }}>
								{t("paypal")}
							</div>
							<p style={{ margin: "0", color: "grey" }}>{t("paypalText")}</p>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Box mt={1} className="h1">
								<Image
									alt="ratenkauf"
									src="https://res.cloudinary.com/safehero/image/upload/v1572510112/HelpCenter/ngul6uuyzdruvdgygsvd.png"
									width={70}
									height={20}
									style={{
										maxWidth: "100%",
										height: "auto",
										objectFit: "contain",
									}}
								/>
							</Box>
							<div className="h1" style={{ fontSize: "20px" }}>
								{t("klarnaPayOverTime")}
							</div>
							<p style={{ margin: "0", color: "grey" }}>
								{t("klarnaPayOverTimeText")}
							</p>
						</Grid>
						<Grid item xs={12} sm={6}>
							<Box mt={1} className="h1">
								<Image
									alt="sofortüberweisung"
									src="https://res.cloudinary.com/safehero/image/upload/v1572510112/HelpCenter/ngul6uuyzdruvdgygsvd.png"
									width={70}
									height={20}
									style={{
										maxWidth: "100%",
										height: "auto",
										objectFit: "contain",
									}}
								/>
							</Box>
							<div className="h1" style={{ fontSize: "20px" }}>
								{t("klarnaPayNow")}
							</div>
							<p style={{ margin: "0", color: "grey" }}>{t("klarnaPayNowText")}</p>
						</Grid>
					</Grid>
				</Hidden>
			</Container>
			<Container>
				<Help />
			</Container>
		</Box>
	)
}

export const getStaticProps: GetStaticProps = async (context) => {
	const props = {
		...(await getServerTranslations(context.locale, [
			"common",
			"countries",
			"languages",
			"help",
			"category",
		])),
	}

	return {
		props,
	}
}

export default PaymentInformation
